import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { CmsScreensaver } from '@nsftx/seven-client-retail-vue-sgp'
import { useIdleTimer } from '@nsftx/seven-nxg-retail-vue-sdk'

export const useScreensaverStore = defineStore('screensaverStore', () => {
  const isScreensaverShown = ref(false)
  const screensaverIdleTimer = ref<ReturnType<typeof useIdleTimer> | null>(null)
  const screensaverData = ref<CmsScreensaver>({
    enabled: false,
    mediaSource: null,
    url: null
  })

  const isScreensaverEnabled = computed(() => screensaverData.value.enabled)

  const hasScreensaverData = computed(
    () => !!screensaverData.value.url && !!screensaverData.value.mediaSource
  )

  const shouldShowScreensaver = computed(
    () => isScreensaverEnabled.value && isScreensaverShown.value && hasScreensaverData.value
  )

  const setScreensaverData = (data: CmsScreensaver | null) => {
    if (!data) return

    screensaverData.value = { ...data }
  }

  const showScreensaver = () => {
    isScreensaverShown.value = true
  }

  const hideScreensaver = () => {
    isScreensaverShown.value = false
    screensaverIdleTimer.value?.resetIdleTimer()
  }

  return {
    screensaverData,
    screensaverIdleTimer,
    isScreensaverEnabled,
    isScreensaverShown,
    shouldShowScreensaver,
    hasScreensaverData,
    showScreensaver,
    hideScreensaver,
    setScreensaverData
  }
})
